import React from 'react';

import { DEFAULT_STYLES } from '../../constants';
import { ComboBoxMobileSheetProps } from '../../types/comboBoxComponentTypes';

import { BottomSheet } from '../BottomSheet';

export const ComboBoxMobileSheet: React.FC<ComboBoxMobileSheetProps> = ({
  isOpen,
  label,
  isClosingRef,
  onClose,
  searchInput,
  optionsList,
  loadingContent,
  isCurrentlyLoading,
  loadingState,
  addItemButton
}) => (
  <BottomSheet
    isOpen={isOpen}
    onClose={() => {
      if (!isClosingRef.current) {
        onClose();
      }
    }}
    title={label}
    showCloseButton={true}
    className={DEFAULT_STYLES.combobox__bottomSheet}
    topContent={searchInput}
    footer={addItemButton}
    autoFocus={false}
  >
    {isCurrentlyLoading && loadingState !== 'loadingMore'
      ? loadingContent
      : optionsList}
  </BottomSheet>
);

ComboBoxMobileSheet.displayName = 'ComboBoxMobileSheet';
